module.exports = __webpack_public_path__ + "static/media/carta_42.437f9325.jpg";